import React from 'react';


const HotlinesContent = () => {
    return (
        <div className="grid justify-center h-64 pt-3">
            <img src="https://pbs.twimg.com/media/B4TbazVCAAEi9Dk.jpg" alt="hotlines"></img>
        </div>
    )
}

export default HotlinesContent;
